import { httpClient } from '../api/http';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

// Target is the only wallet that needs a targetId alongside the userId.
const useInterestBreakdown = (walletName: string, targetId?: string, enabled = true) => {
  const params = useParams();
  const userIdIn = params.id as string;

  const queryString = targetId ? `?targetId=${targetId}` : '';

  const { data: interestBreakdown, isLoading: isLoadingInterestBreakdown } = useQuery({
    queryKey: ['interest-breakdown', walletName, userIdIn, targetId],
    enabled: enabled && !!userIdIn && !!walletName,
    queryFn: () =>
      httpClient
        .get(`admin/wallets/${walletName}/${userIdIn}/interest-breakdown${queryString}`)
        .then((res) => res.data.data),
  });

  return { interestBreakdown, isLoadingInterestBreakdown };
};

export default useInterestBreakdown;
